"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shallowequal = _interopRequireDefault(require("shallowequal"));

var _default = _shallowequal.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/lib/shallowEqual.js
// module id = 2224
// module chunks = 0